import React, { useState } from 'react';
import { Modal, Button, ButtonEnums } from 'components/atoms';
import styled from 'styled-components/macro';
import { ActionResultModal } from 'components/organisms/FirmDataTable/ActionResultModal';
import { ActionResult } from 'constants/firm-admin';

export const FormSuccessModal: React.FC<{ onClose?: () => void }> = ({ onClose }) => {
  const [open, setOpen] = useState(true);

  function modalHandler() {
    setOpen(!open);
    if (onClose) return onClose();
  }

  return (
    <StyledModal
      open={open}
      onClose={modalHandler}
      testId="ineligible-membership-type"
      cancelNode={
        <Button
          size={ButtonEnums.sizes.small}
          variant={ButtonEnums.variants.primary}
          testId="no-follow"
          onClick={modalHandler}
        >
          Okay
        </Button>
      }
    >
      <ActionResultModal
        resultTitle="Success!"
        status={ActionResult.Success}
        showResult
        resultHelperText="Thank you for your inquiry. We’ll be in touch soon."
      />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  &&&& > button {
    position: absolute !important;
    top: ${props => props.theme.pxToRem(16)}!important;
    right: ${props => props.theme.pxToRem(16)}!important;
  }

  &&&& {
    width: ${props => props.theme.pxToRem(590)};
    background: ${props => props.theme.colors.neutralWhite};
    margin-top: ${props => props.theme.pxToRem(48)};
    border-radius: ${props => props.theme.pxToRem(2)};
    padding: ${props => props.theme.pxToRem(15)} 0 ${props => props.theme.pxToRem(20)}!important;
    box-sizing: border-box;

    ${props => props.theme.mediaQueries.mobileOnly} {
      width: 90%;
      margin-left: auto;
      margin-right: auto;
    }

    > .content {
      margin: 0 !important;
      text-align: center;
      box-sizing: border-box;
      padding: ${props => props.theme.pxToRem(30)} ${props => props.theme.pxToRem(40)}!important;
    }

    > .header {
      margin: 0 auto;
      text-align: center;
      display: table;
      h2 {
        margin: 0 auto;
        font-size: ${props => props.theme.fontSizes.l};
      }
    }

    > .actions {
      margin: 0 ${props => props.theme.pxToRem(20)};
    }
  }

  button > svg {
    fill: ${props => props.theme.colors.primaryDarkPurple};
  }
`;
